import API from "../../api/API";
import { useMutation } from "@tanstack/react-query";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { newToastEvent } from "../../../utils/ToastUtil";

interface MutationProps {
  payload: any;
  onSuccess?: () => void;
}

const useUpdateClouds = () => {
  const updateClouds = useMutation({
    mutationFn: ({ payload }: MutationProps) => {
      return API.updateClouds(payload);
    },
    onSuccess: async (_, { onSuccess }) => {
      newToastEvent("success", "Successfully updated clouds");
      callFunctionIfExists(onSuccess);
    },
    onError: (err) => {
      newToastEvent(
        "error",
        `Error updating clouds! Error: ${getErrorMessage(err)}`
      );
    },
  });

  return {
    updateClouds: updateClouds.mutate,
    updatingClouds: updateClouds.isPending,
    updateCloudsError: updateClouds.error
      ? getErrorMessage(updateClouds.error)
      : null,
  };
};

export default useUpdateClouds;
